module.exports = __webpack_public_path__ + "img/avatar0.9a1c7d0d.png";